import CartConstants from './CartConsts';
import { Product } from '../../Entities/Product.ts';

const savedCart = JSON.parse(localStorage.getItem('cart')) || [];

const initialState = {
    cartItems: savedCart,
    // Calculate initial totals using the Product Class getters
    totalAmount: savedCart.reduce((sum, item) => sum + (Product.fromObject(item).finalPrice * item.quantity), 0),
    totalItems: savedCart.reduce((sum, item) => sum + item.quantity, 0),
    products: [] 
};

export default function cartReducer(state = initialState, action) {
    switch (action.type) {
        
        case CartConstants.ADD_PRODUCT_TO_CART: {
            const productPayload = action.payload;
            const stockOnHand    = productPayload.inventory?.stockOnHand ?? Infinity;
            const existingIndex  = state.cartItems.findIndex(item => item.id === productPayload.id);

            let updatedItems;
            let addedQty;

            if (existingIndex !== -1) {
                const existingQty = state.cartItems[existingIndex].quantity;
                const newQty      = Math.min(existingQty + productPayload.quantity, stockOnHand);
                addedQty          = newQty - existingQty;
                updatedItems      = state.cartItems.map((item, i) =>
                    i === existingIndex ? { ...item, quantity: newQty } : item
                );
            } else {
                addedQty     = Math.min(productPayload.quantity, stockOnHand);
                updatedItems = [...state.cartItems, { ...productPayload, quantity: addedQty }];
            }

            localStorage.setItem('cart', JSON.stringify(updatedItems));

            return {
                ...state,
                cartItems: updatedItems,
                totalAmount: state.totalAmount + (Product.fromObject(productPayload).finalPrice * addedQty),
                totalItems:  state.totalItems + addedQty,
            };
        }

        case CartConstants.REMOVE_PRODUCT_FROM_CART: {
            const itemToRemove = state.cartItems.find(item => item.id === action.payload);
            const updatedItems = state.cartItems.filter(item => item.id !== action.payload);

            localStorage.setItem('cart', JSON.stringify(updatedItems));

            return {
                ...state,
                cartItems: updatedItems,
                totalAmount: state.totalAmount - (itemToRemove ? Product.fromObject(itemToRemove).finalPrice * itemToRemove.quantity : 0),
                totalItems: state.totalItems - (itemToRemove ? itemToRemove.quantity : 0)
            };
        }

        case CartConstants.EDIT_PRODUCT_IN_CART: {
            const maxQty       = action.payload.inventory?.stockOnHand ?? Infinity;
            const clampedQty   = Math.min(action.payload.quantity, maxQty);
            const updatedItems = state.cartItems.map(item =>
                item.id === action.payload.id ? { ...item, ...action.payload, quantity: clampedQty } : item
            );
            
            localStorage.setItem('cart', JSON.stringify(updatedItems));

            return {
                ...state,
                cartItems: updatedItems,
                totalAmount: updatedItems.reduce((acc, item) => acc + (Product.fromObject(item).finalPrice * item.quantity), 0),
                totalItems: updatedItems.reduce((acc, item) => acc + item.quantity, 0)
            };
        }

        case CartConstants.CLEAR_CART:
            localStorage.setItem('cart', JSON.stringify([]));
            return { ...state, cartItems: [], totalAmount: 0, totalItems: 0 };

        case CartConstants.FETCH_PRODUCTS_SUCCESS:
            return { ...state, products: action.payload.data || [] };

        default:
            return state;
    }
}